<div class="page-head">
  <div>
    <p class="eyebrow">การเงิน</p>
    <h1>รายการรายจ่าย</h1>
    <p>ติดตามค่าใช้จ่ายและคอมมิชชั่นที่ฝ่ายบัญชีดำเนินการ</p>
  </div>
  <button
    type="button"
    class="tw-button inline-flex items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] active:scale-[0.98]"
    (click)="exportExcel()"
  >
    <lucide-icon name="Download" [size]="17" />
    Export Excel
  </button>
</div>

<section class="mt-5 rounded-xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
  <div>
    <div class="mb-4">
      <h2 class="m-0 text-base font-bold text-slate-800">ตัวกรองรายการ</h2>
      <p class="mt-1 mb-0 text-xs text-slate-500">เลือกช่วงวันที่ ประเภทรายจ่าย และสถานะ</p>
    </div>

    <div class="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
      <label class="block">
        <span class="mb-1.5 block text-xs font-semibold text-slate-600">วันที่เริ่มต้น</span>
        <p-datepicker
          class="w-full"
          [ngModel]="pendingDateFrom()"
          (ngModelChange)="pendingDateFrom.set($event)"
          dateFormat="dd/mm/yy"
          placeholder="เลือกวันที่เริ่มต้น"
          [showIcon]="true"
          [showClear]="true"
          [readonlyInput]="true"
          appendTo="body"
        />
      </label>
      <label class="block">
        <span class="mb-1.5 block text-xs font-semibold text-slate-600">วันที่สิ้นสุด</span>
        <p-datepicker
          class="w-full"
          [ngModel]="pendingDateTo()"
          (ngModelChange)="pendingDateTo.set($event)"
          dateFormat="dd/mm/yy"
          placeholder="เลือกวันที่สิ้นสุด"
          [showIcon]="true"
          [showClear]="true"
          [readonlyInput]="true"
          appendTo="body"
        />
      </label>
      <label class="block">
        <span class="mb-1.5 block text-xs font-semibold text-slate-600">ประเภทรายจ่าย</span>
        <p-select
          class="w-full"
          [options]="categoryOptions"
          [ngModel]="pendingCategory()"
          (ngModelChange)="pendingCategory.set($event)"
          optionLabel="label"
          optionValue="value"
          placeholder="เลือกประเภทรายจ่าย"
        />
      </label>
      <label class="block">
        <span class="mb-1.5 block text-xs font-semibold text-slate-600">สถานะ</span>
        <p-select
          class="w-full"
          [options]="statusOptions"
          [ngModel]="pendingStatus()"
          (ngModelChange)="pendingStatus.set($event)"
          optionLabel="label"
          optionValue="value"
          placeholder="เลือกสถานะ"
        />
      </label>
    </div>

    <div class="mt-4 flex flex-wrap justify-center gap-2">
      <button
        type="button"
        class="tw-button inline-flex items-center justify-center gap-1.5 rounded-lg bg-[var(--theme-color)] px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[var(--theme-hover)] active:scale-[0.98]"
        (click)="applyFilters()"
      >
        <lucide-icon name="Search" [size]="16" /> ค้นหา
      </button>
      <button
        type="button"
        class="tw-button inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-600 hover:bg-slate-50"
        (click)="resetFilters()"
      >
        <lucide-icon name="RotateCcw" [size]="15" /> ล้างค่า
      </button>
    </div>
  </div>
</section>

<section class="mt-5 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
  <div class="flex flex-col gap-4 border-b border-slate-200 px-5 py-4 lg:flex-row lg:items-end lg:justify-between sm:px-6">
    <div>
      <h2 class="m-0 text-base font-bold text-slate-800">รายการรายจ่าย</h2>
      <p class="mt-1 mb-0 text-xs text-slate-500">แสดงค่าใช้จ่ายและคอมมิชชั่นตามสถานะรายการจ่าย</p>
    </div>
    <div class="flex w-full flex-wrap items-center gap-2 lg:w-auto lg:justify-end">
      <span class="rounded-full bg-slate-100 px-2.5 py-1.5 text-[10px] font-semibold text-slate-600">
        {{ filteredItems().length }} รายการ
      </span>
      <span class="rounded-full bg-rose-50 px-2.5 py-1.5 text-[10px] font-semibold text-rose-700 tabular-nums">
        {{ expenseTotal() | number: '1.2-2' }}
      </span>
      <label class="relative block w-full sm:w-96">
        <lucide-icon
          name="Search"
          [size]="16"
          class="pointer-events-none absolute top-1/2 left-3 z-10 -translate-y-1/2 text-slate-400"
        />
        <input
          pInputText
          type="search"
          class="h-10 w-full pr-3 text-sm placeholder:text-slate-400"
          style="padding-left: 2.75rem; border-radius: 0.5rem"
          placeholder="ค้นหาเลขรายการ, Booking, ทัวร์, รายละเอียด หรือพนักงาน"
          [ngModel]="searchTerm()"
          (ngModelChange)="searchTerm.set($event)"
        />
      </label>
    </div>
  </div>

  <p-table
    [value]="filteredItems()"
    dataKey="id"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 25, 50]"
    [rowHover]="true"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="แสดง {first} ถึง {last} จาก {totalRecords} รายการ"
    [tableStyle]="{ 'min-width': '1960px' }"
  >
    <ng-template #header>
      <tr>
        <th class="w-14 px-5 py-3 text-center font-semibold whitespace-nowrap">ลำดับ</th>
        <th pSortableColumn="paymentDate" class="min-w-48 px-5 py-3 font-semibold whitespace-nowrap">
          วันที่และเลขรายการ <p-sortIcon field="paymentDate" />
        </th>
        <th pSortableColumn="transferredAt" class="min-w-44 px-5 py-3 font-semibold whitespace-nowrap">
          วันเวลาโอน <p-sortIcon field="transferredAt" />
        </th>
        <th pSortableColumn="bookingNo" class="min-w-52 px-5 py-3 font-semibold whitespace-nowrap">
          Booking และลูกค้า <p-sortIcon field="bookingNo" />
        </th>
        <th pSortableColumn="tourCode" class="min-w-60 px-5 py-3 font-semibold whitespace-nowrap">
          รหัสและชื่อทัวร์ <p-sortIcon field="tourCode" />
        </th>
        <th pSortableColumn="category" class="min-w-56 px-5 py-3 font-semibold whitespace-nowrap">
          ประเภทและรายละเอียด <p-sortIcon field="category" />
        </th>
        <th class="min-w-52 px-5 py-3 font-semibold whitespace-nowrap">ผู้เบิก / ผู้อนุมัติ</th>
        <th pSortableColumn="paymentMethod" class="min-w-40 px-5 py-3 font-semibold whitespace-nowrap">
          ช่องทางชำระ <p-sortIcon field="paymentMethod" />
        </th>
        <th pSortableColumn="status" class="min-w-32 px-5 py-3 text-center font-semibold whitespace-nowrap">
          สถานะ <p-sortIcon field="status" />
        </th>
        <th pSortableColumn="amount" class="min-w-44 px-5 py-3 text-right font-semibold whitespace-nowrap">
          ยอดจ่าย <p-sortIcon field="amount" />
        </th>
        <th pSortableColumn="withholdingTaxAmount" class="min-w-44 px-5 py-3 text-right font-semibold whitespace-nowrap">
          หัก ณ ที่จ่าย <p-sortIcon field="withholdingTaxAmount" />
        </th>
        <th class="w-32 px-5 py-3 text-center font-semibold whitespace-nowrap">ใบเสร็จ</th>
        <th class="w-24 px-5 py-3 text-center font-semibold whitespace-nowrap">ดำเนินการ</th>
      </tr>
    </ng-template>

    <ng-template #body let-item let-rowIndex="rowIndex">
      <tr class="transition even:bg-slate-50/40 hover:bg-sky-50/50">
        <td class="px-5 py-3.5 text-[13px] text-slate-400 tabular-nums" style="vertical-align: middle">
          <div class="flex w-full items-center justify-center">{{ rowIndex + 1 }}</div>
        </td>
        <td class="px-5 py-3.5 align-top">
          <p class="m-0 text-sm font-semibold whitespace-nowrap text-slate-800">
            {{ item.paymentDate | date: 'dd MMM yyyy' }}
          </p>
          <p class="mt-1 mb-0 text-xs font-medium whitespace-nowrap text-sky-700">
            {{ item.transactionNo }}
          </p>
        </td>
        <td class="px-5 py-3.5 text-sm whitespace-nowrap text-slate-600 align-top">
          @if (item.transferredAt) {
            {{ item.transferredAt | date: 'dd/MM/yyyy HH:mm' }} น.
          } @else {
            <span class="text-slate-400">—</span>
          }
        </td>
        <td class="px-5 py-3.5 align-top">
          <p class="m-0 text-sm font-semibold whitespace-nowrap text-sky-700">{{ item.bookingNo }}</p>
          <p class="mt-1 mb-0 text-xs text-slate-500">{{ item.customerName }}</p>
        </td>
        <td class="px-5 py-3.5 align-top">
          <p class="m-0 text-sm font-semibold text-slate-700">{{ item.tourCode || '—' }}</p>
          <p class="mt-1 mb-0 text-xs text-slate-500">{{ item.tourName }}</p>
          <p class="mt-1 mb-0 text-[10px] text-slate-400">{{ item.country || '—' }}</p>
        </td>
        <td class="px-5 py-3.5 align-top">
          <p class="m-0 text-sm font-medium text-slate-700">{{ categoryLabel(item.category) }}</p>
          <p class="mt-1 mb-0 text-xs text-slate-500">{{ item.description }}</p>
        </td>
        <td class="px-5 py-3.5 align-top">
          <p class="m-0 text-sm text-slate-700">{{ item.requestedByName }}</p>
          <p class="mt-1 mb-0 text-xs text-slate-500">อนุมัติโดย {{ item.approvedByName }}</p>
          <p class="mt-1 mb-0 text-[10px] text-slate-400">
            {{ item.approvedAt | date: 'dd/MM/yyyy HH:mm' }} น.
          </p>
        </td>
        <td class="px-5 py-3.5 text-sm text-slate-600 align-top">
          <p class="m-0 text-sm text-slate-700">{{ paymentMethodLabel(item.paymentMethod) }}</p>
          @if (item.bankName || item.accountNumber) {
            <p class="mt-1 mb-0 text-xs leading-5 text-slate-500">
              {{ item.bankName || 'ไม่ระบุธนาคาร' }}
            </p>
            <p class="mt-0.5 mb-0 text-xs leading-5 text-slate-500">
              เลขบัญชี {{ item.accountNumber || '—' }}
            </p>
          }
        </td>
        <td class="px-5 py-3.5 text-center align-top">
          <app-status-badge
            [status]="item.status"
            [displayLabel]="item.status === 'PAID' ? 'ชำระแล้ว' : undefined"
          />
        </td>
        <td class="px-5 py-3.5 text-right text-sm font-semibold whitespace-nowrap text-rose-700 tabular-nums align-top">
          {{ item.amount | number: '1.2-2' }}
        </td>
        <td class="px-5 py-3.5 text-right text-sm font-semibold whitespace-nowrap text-amber-700 tabular-nums align-top">
          {{ item.withholdingTaxAmount | number: '1.2-2' }}
        </td>
        <td class="px-5 py-3.5 text-center align-middle">
          @if (receiptDocumentUrl(item); as receiptUrl) {
            <button
              type="button"
              class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition hover:border-sky-200 hover:bg-sky-50 hover:text-sky-700"
              title="เปิดใบเสร็จ"
              aria-label="เปิดใบเสร็จในแท็บใหม่"
              (click)="openDocument(receiptUrl)"
            >
              <lucide-icon name="ExternalLink" [size]="14" />
            </button>
          } @else {
            <span class="text-sm text-slate-400">—</span>
          }
        </td>
        <td class="px-5 py-3.5 text-center align-middle">
          @if (item.status === 'PAID') {
            <button
              type="button"
              class="tw-button inline-flex size-8 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition hover:border-sky-200 hover:bg-sky-50 hover:text-sky-700"
              title="แก้ไขข้อมูลโอนจ่าย"
              aria-label="แก้ไขข้อมูลโอนจ่าย"
              (click)="openEditDocument(item)"
            >
              <lucide-icon name="Pencil" [size]="14" />
            </button>
          }
        </td>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td colspan="13" class="px-5 py-12 text-center">
          <div class="mx-auto grid size-12 place-items-center rounded-full bg-slate-100 text-slate-400">
            <lucide-icon name="SearchX" [size]="21" />
          </div>
          <h3 class="mt-3 mb-0 text-sm font-semibold text-slate-700">ไม่พบรายการรายจ่าย</h3>
          <p class="mt-1 mb-0 text-xs text-slate-500">ลองเปลี่ยนคำค้นหา ช่วงวันที่ หรือตัวกรอง</p>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>

@if (selectedExpense(); as expense) {
  <div
    class="fixed inset-0 z-[200] grid place-items-center overflow-y-auto bg-slate-950/45 p-4 backdrop-blur-[2px]"
    (click)="closeEditDocument()"
  >
    <section
      class="my-auto w-full max-w-2xl max-h-[calc(100vh-2rem)] overflow-y-auto rounded-2xl border border-slate-200 bg-white shadow-2xl"
      role="dialog"
      aria-modal="true"
      aria-labelledby="edit-expense-document-title"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-start justify-between border-b border-slate-200 px-5 py-5 sm:px-6">
        <div>
          <p class="mb-1 text-xs font-semibold tracking-wider text-sky-600 uppercase">
            {{ expense.transactionNo }}
          </p>
          <h2 id="edit-expense-document-title" class="m-0 text-xl font-bold text-slate-800">
            แก้ไขข้อมูลโอนจ่าย
          </h2>
          <p class="mt-1 mb-0 text-xs text-slate-500">
            {{ expense.bookingNo }} · {{ expense.description }}
          </p>
        </div>
        <button
          type="button"
          class="tw-button inline-flex size-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
          aria-label="ปิดหน้าต่าง"
          (click)="closeEditDocument()"
        >
          <lucide-icon name="X" [size]="19" />
        </button>
      </div>

      <div class="grid items-start gap-4 p-5 sm:grid-cols-2 sm:p-6">
        <label class="grid content-start gap-1.5 text-sm font-semibold text-slate-700">
          <span>วันที่โอนเงิน <span class="text-red-500">*</span></span>
          <p-datepicker
            class="w-full font-normal"
            [ngModel]="editTransferDate()"
            (ngModelChange)="editTransferDate.set($event); clearTransferDateTimeError()"
            dateFormat="dd/mm/yy"
            placeholder="เลือกวันที่โอนเงิน"
            [showIcon]="true"
            [readonlyInput]="true"
            appendTo="body"
          />
        </label>
        <label class="grid content-start gap-1.5 text-sm font-semibold text-slate-700">
          <span>เวลาโอนเงิน <span class="text-red-500">*</span></span>
          <p-datepicker
            class="w-full font-normal"
            [ngModel]="editTransferTime()"
            (ngModelChange)="editTransferTime.set($event); clearTransferDateTimeError()"
            [timeOnly]="true"
            hourFormat="24"
            placeholder="เลือกเวลาโอนเงิน"
            [showIcon]="true"
            [readonlyInput]="true"
            appendTo="body"
          />
        </label>
        <label class="grid content-start gap-1.5 text-sm font-semibold text-slate-700 sm:col-span-2">
          <span>ลิงก์สลิปโอนจ่าย</span>
          <input
            type="url"
            pInputText
            class="h-11 w-full font-normal"
            [class.p-invalid]="!!documentUrlError()"
            [ngModel]="editDocumentUrl()"
            (ngModelChange)="editDocumentUrl.set($event); clearDocumentUrlError()"
            placeholder="https://example.com/payment-slip"
          />
          @if (documentUrlError()) {
            <small class="font-normal text-red-600">{{ documentUrlError() }}</small>
          }
        </label>
        <label class="grid content-start gap-1.5 text-sm font-semibold text-slate-700 sm:col-span-2">
          <span>ยอดหัก ณ ที่จ่าย</span>
          <p-inputnumber
            class="w-full font-normal"
            inputStyleClass="h-11 w-full"
            [ngModel]="editWithholdingTaxAmount()"
            (ngModelChange)="editWithholdingTaxAmount.set($event ?? 0); clearWithholdingTaxError()"
            mode="currency"
            currency="THB"
            locale="th-TH"
            [min]="0"
            [max]="expense.amount"
            [class.p-invalid]="!!withholdingTaxError()"
            placeholder="0.00"
          />
          @if (withholdingTaxError()) {
            <small class="font-normal text-red-600">{{ withholdingTaxError() }}</small>
          }
        </label>
        @if (transferDateTimeError()) {
          <small class="sm:col-span-2 font-normal text-red-600">{{ transferDateTimeError() }}</small>
        }
      </div>

      <div class="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4 sm:flex-row sm:justify-end sm:px-6">
        <button
          type="button"
          class="tw-button h-11 rounded-xl border border-slate-300 bg-white px-5 text-sm font-semibold text-slate-700 hover:bg-slate-100"
          (click)="closeEditDocument()"
        >
          ยกเลิก
        </button>
        <button
          type="button"
          class="tw-button inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-[var(--theme-color)] px-5 text-sm font-semibold text-white hover:bg-[var(--theme-hover)]"
          (click)="saveDocumentLink()"
        >
          <lucide-icon name="Check" [size]="17" /> บันทึก
        </button>
      </div>
    </section>
  </div>
}
